// Basic
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
// Store & actions
import useSessionStore from '@/app/store/session';
// Components
import Dropdown from '../../../../../common-utils/components/renders/dropdown/Dropdown';
import ModalUpdateLabel from '../modals/ModalUpdateLabel';
import ModalRemoveContract from '../modals/ModalRemoveContract';
// Common
import ICONS from '../../../../../common-utils/enums/icons';
import Permissions from '@/app/permissions/Permissions';
// Lang
import { nsContract } from '@/app/i18n/namespaces';
import hasRequiredPermissions from '@/common-utils/functions/hasRequiredPermissions';

/**
 * @param {Object} props
 * @param {Object} props.contract
 * @param {Function} props.setLaunchRefetch
 * @param {string} props.toastSuccess
 * @returns {JSX} DropdownContractActionsRow
 */
function DropdownContractActionsRow({ contract, setLaunchRefetch, toastSuccess }) {
    // Store
    const permissions = useSessionStore(s => s.session.permissions);

    // State
    const [showModalUpdateLabel, setShowModalUpdateLabel] = useState(false);
    const [showModalRemoveContract, setShowModalRemoveContract] = useState(false);

    // Get contractAccessId from URL params
    const { contractAccessId: merchantAccountId } = useParams();

    return (
        <>
            <Dropdown
                dataCy='contracts-actions-dropdown-row'
                triggerValues={{ variant: 'ghostNoBorder', icon: ICONS.MORE }}
                actions={[
                    {
                        icon: ICONS.EDIT,
                        entity: 'actions.row.update_label',
                        namespace: nsContract,
                        onClick: () => setShowModalUpdateLabel(true),
                        visible: true,
                        disabled: !hasRequiredPermissions({
                            permissions: permissions,
                            requiredPermissions: [Permissions.CONTRACTS_ACCESS_UPDATE_CONTRACT_PROFILE.name]
                        }),
                        tooltipForbidden: 'title.permissions.access_denied'
                    },
                    {
                        icon: ICONS.SUBSCRIPTION_TERMINATE,
                        entity: 'actions.row.remove',
                        namespace: nsContract,
                        onClick: () => setShowModalRemoveContract(true),
                        visible: true,
                        disabled: !hasRequiredPermissions({
                            permissions: permissions,
                            requiredPermissions: [Permissions.CONTRACTS_ACCESS_DELETE_CONTRACT_PROFILE.name]
                        }),
                        tooltipForbidden: 'title.permissions.access_denied'
                    }
                ]}
            />
            <ModalUpdateLabel
                isOpen={showModalUpdateLabel}
                setIsOpen={setShowModalUpdateLabel}
                contractId={contract.uuid}
                label={contract.merchantLabel}
                merchantAccountId={merchantAccountId}
                setLaunchRefetch={setLaunchRefetch}
            />
            <ModalRemoveContract
                isOpen={showModalRemoveContract}
                setIsOpen={setShowModalRemoveContract}
                contractId={contract.uuid}
                merchantAccountId={merchantAccountId}
                setLaunchRefetch={setLaunchRefetch}
                toastSuccess={toastSuccess}
            />
        </>
    );
}

DropdownContractActionsRow.propTypes = {
    contract: PropTypes.object.isRequired,
    setLaunchRefetch: PropTypes.func.isRequired,
    toastSuccess: PropTypes.string
};

export default DropdownContractActionsRow;